import { createQueryProvider } from '@/modules/auto-query-context'
import { useMessageMedias } from '@/modules/message/query/message-media-query'

export const { MessageMediaQueryProvider, useMessageMediaQuery } =
  createQueryProvider('MessageMediaQuery', useMessageMedias)
